module.exports = __webpack_public_path__ + "img/elementlengths_jak.56ab9b38.png";